(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker-backup"] && !Shopify.designMode) return;
  try {
    (function () {
    let isSubscribed = false;
    let enforceTimer = null;

    function getSelect() {
      const vp = document.querySelector('variant-picker');
      return vp ? vp.querySelector('select.variant-option__select') : null;
    }

    function getSellingPlanRadio() {
      return document.querySelector('.subscription_group input[data-radio-type="selling_plan"]');
    }

    function applyDisabled() {
      const select = getSelect();
      if (!select) return;
      if (!select.disabled) select.disabled = true;
      const wrap = select.closest('.variant-option__select-wrapper');
      if (wrap && !wrap.classList.contains('is-disabled')) {
        wrap.classList.add('is-disabled');
      }
    }

    function applyEnabled() {
      const select = getSelect();
      if (!select) return;
      if (select.disabled) select.disabled = false;
      const wrap = select.closest('.variant-option__select-wrapper');
      if (wrap && wrap.classList.contains('is-disabled')) {
        wrap.classList.remove('is-disabled');
      }
    }

    function startEnforcing() {
      stopEnforcing();
      enforceTimer = setInterval(function () {
        if (!isSubscribed) {
          stopEnforcing();
          return;
        }

        const select = getSelect();
        if (select && select.selectedIndex !== 0) {
          select.selectedIndex = 0;
        }
        applyDisabled();

        const radio = getSellingPlanRadio();
        if (radio && !radio.checked) {
          radio.checked = true;
        }
      }, 200);
    }

    function stopEnforcing() {
      if (enforceTimer) {
        clearInterval(enforceTimer);
        enforceTimer = null;
      }
    }

    document.addEventListener('change', function (e) {
      const radio = e.target.closest('input[data-radio-type]');
      if (!radio) return;

      if (radio.dataset.radioType === 'selling_plan') {
        isSubscribed = true;
        const select = getSelect();
        if (select) select.selectedIndex = 0;
        applyDisabled();
        startEnforcing();
      } else if (radio.dataset.radioType === 'one_time_purchase') {
        isSubscribed = false;
        stopEnforcing();
        applyEnabled();
      }
    });
  })();

  // --- Enable the "additional veneer" dropdown via its checkbox ---
  // Showing/hiding is handled purely with CSS (:has(), in the stylesheet above),
  // driven directly off the checkbox's :checked state — correct on first paint,
  // and the <select> is NEVER given the `disabled` attribute, so it always keeps
  // a valid value and never breaks the variant match / Add to cart button.
  //
  // IMPORTANT: this checkbox lives inside <variant-picker>, which listens for
  // ANY 'change' event bubbling up from within it to re-fetch and swap in fresh
  // section HTML (that's how it updates price/availability on a real option
  // change). Our checkbox isn't a real product option, but its 'change' event
  // was bubbling into that same listener, triggering an unwanted re-render that
  // replaced the markup with a fresh, unchecked copy a moment later — that's
  // the "shows then disappears" flicker. Binding directly on the checkbox and
  // calling stopPropagation() stops it from ever reaching that listener.
  //
  // When unchecked, we also want the address bar's "?variant=..." to point at
  // the default (no-veneer) variant instead of whatever was last selected, e.g.
  //   /products/foo?variant=52911196012861  ->  /products/foo?variant=<default-id>
  // so anything on the page reading that param (like the free-gift unlock tiers)
  // reflects the default state. Done directly with history.replaceState, so it
  // happens instantly without a page reload or triggering another section re-render.
  (function () {
    // Remembers what the person actually chose, independent of the DOM.
    // A legitimate section re-render (picking a different color/size elsewhere
    // in the same <variant-picker>) replaces this checkbox with a fresh,
    // unchecked copy from the server — without this, that would silently
    // "uncheck" it even though the person never touched it.
    let userWantsVeneer = false;

    function getDefaultVariantId(container) {
      const select = container && container.querySelector('[data-variant-select]');
      const firstOption = select && select.options[0];
      return firstOption ? firstOption.getAttribute('data-variant-id') : null;
    }

    function findCartVariantInput() {
      const form = document.querySelector('form[action*="/cart/add"]');
      return form ? form.querySelector('input[name="id"], select[name="id"]') : null;
    }

    function resetToDefaultVariant(container) {
      const defaultVariantId = getDefaultVariantId(container);

      // Reset the visible veneer dropdown itself. This MUST bubble: it's the
      // only thing that reaches <variant-picker>'s own change listener, which
      // is what triggers its section re-fetch and swaps the price block back
      // to the default variant's price. Firing this as non-bubbling (the old
      // behavior) reset the visible dropdown and the hidden cart-form input
      // correctly, but left the on-page price stuck on whatever tier was last
      // selected, since <variant-picker> never found out anything changed.
      const select = container && container.querySelector('[data-variant-select]');
      if (select && select.selectedIndex !== 0) {
        select.selectedIndex = 0;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (!defaultVariantId) return;

      // The gift-unlock script (veneer-addon-block) reads the REAL hidden
      // variant id input in the /cart/add form — not the URL — via a 'change'
      // listener, a MutationObserver, and a 250ms poll. Update it for real and
      // fire a normal bubbling 'change' so it (and anything else watching it,
      // like price/availability) picks up the reset immediately.
      const variantInput = findCartVariantInput();
      if (variantInput && variantInput.value !== defaultVariantId) {
        variantInput.value = defaultVariantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Instant path: skip waiting on the listener/poll entirely if the gift
      // script has exposed its reset hook.
      if (typeof window.veneerGiftsReset === 'function') {
        window.veneerGiftsReset();
      }

      // Same instant path for the bundle-contents block: it exposes its own
      // reset hook (window.bundleReset) that snaps bundle-one/two/three back
      // to bundle-one, mirroring window.veneerGiftsReset above. Guarded the
      // same way, so nothing breaks on products that don't include that block.
      if (typeof window.bundleReset === 'function') {
        window.bundleReset();
      }

      // Keep the address bar in sync too.
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', defaultVariantId);
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (err) {
        // Fail silently — worst case the URL just keeps whatever it had.
      }
    }

    function handleToggleChange(event) {
      event.stopPropagation();

      const toggle = event.currentTarget;
      userWantsVeneer = toggle.checked; // this IS the user's explicit action

      if (toggle.checked) return;

      resetToDefaultVariant(toggle.closest('[data-variant-toggle]'));
    }

    function bindToggles(root) {
      (root || document).querySelectorAll('[data-variant-toggle]').forEach(function (container) {
        const toggle = container.querySelector('.variant-option__toggle');
        if (!toggle) return;

        // Re-apply the last explicit user choice — covers the case where this
        // checkbox is a brand-new element from a section re-render.
        if (toggle.checked !== userWantsVeneer) {
          toggle.checked = userWantsVeneer;
        }

        if (toggle.dataset.toggleBound) return;
        toggle.dataset.toggleBound = 'true';
        toggle.addEventListener('change', handleToggleChange);
      });
    }

    bindToggles(document);
    document.addEventListener('DOMContentLoaded', function () {
      bindToggles(document);
    });

    // Re-bind (and re-apply the remembered choice to) any checkboxes that
    // show up after a genuine section re-render.
    new MutationObserver(function () {
      bindToggles(document);
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    let isSubscribed = false;
    let enforceTimer = null;

    function getSelect() {
      const vp = document.querySelector('variant-picker');
      return vp ? vp.querySelector('select.variant-option__select') : null;
    }

    function getSellingPlanRadio() {
      return document.querySelector('.subscription_group input[data-radio-type="selling_plan"]');
    }

    function applyDisabled() {
      const select = getSelect();
      if (!select) return;
      if (!select.disabled) select.disabled = true;
      const wrap = select.closest('.variant-option__select-wrapper');
      if (wrap && !wrap.classList.contains('is-disabled')) {
        wrap.classList.add('is-disabled');
      }
    }

    function applyEnabled() {
      const select = getSelect();
      if (!select) return;
      if (select.disabled) select.disabled = false;
      const wrap = select.closest('.variant-option__select-wrapper');
      if (wrap && wrap.classList.contains('is-disabled')) {
        wrap.classList.remove('is-disabled');
      }
    }

    function startEnforcing() {
      stopEnforcing();
      enforceTimer = setInterval(function () {
        if (!isSubscribed) {
          stopEnforcing();
          return;
        }

        const select = getSelect();
        if (select && select.selectedIndex !== 0) {
          select.selectedIndex = 0;
        }
        applyDisabled();

        const radio = getSellingPlanRadio();
        if (radio && !radio.checked) {
          radio.checked = true;
        }
      }, 200);
    }

    function stopEnforcing() {
      if (enforceTimer) {
        clearInterval(enforceTimer);
        enforceTimer = null;
      }
    }

    document.addEventListener('change', function (e) {
      const radio = e.target.closest('input[data-radio-type]');
      if (!radio) return;

      if (radio.dataset.radioType === 'selling_plan') {
        isSubscribed = true;
        const select = getSelect();
        if (select) select.selectedIndex = 0;
        applyDisabled();
        startEnforcing();
      } else if (radio.dataset.radioType === 'one_time_purchase') {
        isSubscribed = false;
        stopEnforcing();
        applyEnabled();
      }
    });
  })();

    
  (function () {
    var SELECTOR = 'variant-picker select.variant-option__select';

    function syncOptions(select) {
      var current = select.value;
      Array.from(select.options).forEach(function (opt) {
        var isCurrent = opt.value === current;
        if (opt.hidden !== isCurrent) opt.hidden = isCurrent;
        if (opt.disabled) opt.disabled = false;
        if (isCurrent) {
          opt.style.setProperty('display', 'none', 'important');
        } else {
          opt.style.setProperty('display', 'block', 'important');
        }
      });
    }

    function syncAll() {
      document.querySelectorAll(SELECTOR).forEach(syncOptions);
    }

    syncAll();
    document.addEventListener('DOMContentLoaded', syncAll);

    ['change', 'focusin', 'mousedown', 'touchstart', 'click', 'variant:update'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        syncAll();
        setTimeout(syncAll, 100);
        setTimeout(syncAll, 400);
      }, true);
    });

    setInterval(syncAll, 250);
  })();
  } catch(e) { console.error(e); }
})();

})();
